import {FC, memo} from 'react';

import TableBody from '@mui/material/TableBody';
import {ImportRow} from './ImportRow';
import {TableCell, TableRow} from '@mui/material';

import {IServiceRequestImports} from '../../../../shared/types/serviceRequestImport.types';

interface ITableBodyContainer {
  rowsPerPage: number;
  page: number;
  serviceRequestImports: IServiceRequestImports[];
}

export const TableBodyContainer: FC<ITableBodyContainer> = memo(
  ({rowsPerPage, page, serviceRequestImports}) => {
    const emptyRows = rowsPerPage - serviceRequestImports.length;

    return (
      <TableBody>
        {serviceRequestImports.map((row, index) => {
          return <ImportRow key={row.id} row={row} index={page * rowsPerPage + index + 1} />;
        })}
        {emptyRows > 0 && (
          <TableRow
            style={{
              height: 47 * emptyRows,
            }}
          >
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  },
  (prev, next) => prev.serviceRequestImports === next.serviceRequestImports,
);
